// Yerel SEO açılış sayfaları için slug + hizmet tanımları.
// slugifyTr: Türkçe karakterleri ASCII'ye indirger (İzmir→izmir, Şişli→sisli).
// NOT: Aynı mantık scripts/sitemap-prerender tarafında da tekrarlanır (drift olmasın).

export function slugifyTr(s) {
  return (s || "")
    .replace(/İ/g, "i").replace(/I/g, "i").replace(/ı/g, "i")
    .replace(/Ğ/g, "g").replace(/ğ/g, "g")
    .replace(/Ü/g, "u").replace(/ü/g, "u")
    .replace(/Ş/g, "s").replace(/ş/g, "s")
    .replace(/Ö/g, "o").replace(/ö/g, "o")
    .replace(/Ç/g, "c").replace(/ç/g, "c")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export const LOCAL_SERVICES = {
  "ev-temizligi": { slug: "ev-temizligi", label: "Ev Temizliği", firma: false },
  "hali-yikama": { slug: "hali-yikama", label: "Halı Yıkama", firma: true },
  "koltuk-yikama": { slug: "koltuk-yikama", label: "Koltuk Yıkama", firma: true },
};

export const LOCAL_SERVICE_LIST = Object.values(LOCAL_SERVICES);

// 81 il adı — slug'dan gerçek il adını SENKRON çözmek için (prerender edilmiş
// il sayfalarında başlık ilk render'da doğru gelsin; async gap → çift <title> olmasın).
export const PROVINCE_NAMES = ["Adana", "Adıyaman", "Afyonkarahisar", "Aksaray", "Amasya", "Ankara", "Antalya", "Ardahan", "Artvin", "Aydın", "Ağrı", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis", "Bolu", "Burdur", "Bursa", "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane", "Hakkari", "Hatay", "Isparta", "Iğdır", "İstanbul", "İzmir", "Kahramanmaraş", "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kilis", "Kocaeli", "Konya", "Kütahya", "Kırklareli", "Kırıkkale", "Kırşehir", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas", "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak", "Çanakkale", "Çankırı", "Çorum", "Şanlıurfa", "Şırnak"];

export const PROVINCE_BY_SLUG = Object.fromEntries(PROVINCE_NAMES.map((n) => [slugifyTr(n), n]));

// SEO/prerender/sitemap için öne çıkarılan büyük iller (kapsama yüksek + değerli).
export const MAJOR_CITIES = [
  "İstanbul", "Ankara", "İzmir", "Bursa", "Antalya", "Adana", "Konya",
  "Gaziantep", "Kocaeli", "Mersin", "Kayseri", "Eskişehir", "Samsun", "Denizli", "Muğla",
];
